import SimpleDictionaryFormConfig from '../../components/common/SimpleDictionaryFormConfig';
import SimpleDictionaryTableConfig from '../../components/common/SimpleDictionaryTableConfig';
import AmenityGroupFormConfig from './group/AmenityGroupFormConfig';
import AmenityGroupTableConfig from './group/AmenityGroupTableConfig';
import PaymentTypeFormConfig from './PaymentTypeFormConfig';
import PaymentTypeTableConfig from './PaymentTypeTableConfig';

export const dictionaries = [
  {
    api: 'paymentType',
    label: 'Metody płatności',
    creationLabel: 'Dodaj metodę płatności',
    fields: PaymentTypeFormConfig,
    columns: PaymentTypeTableConfig,
    editable: true,
    editWithId: true,
    withHeader: false,
    deleteModalTitle: 'Usunięcie metody płatności',
    deleteModalDescription: 'Czy na pewno chcesz usunąć tę metodę płatności?',
  },
  {
    api: 'accountingDocumentType',
    label: 'Rodzaje dokumentów księgowych',
    creationLabel: 'Dodaj rodzaj dokumentu',
    fields: SimpleDictionaryFormConfig,
    columns: SimpleDictionaryTableConfig,
    editable: true,
    editWithId: true,
    withHeader: false,
    deleteModalTitle: 'Usunięcie rodzaju dokumentu',
    deleteModalDescription: 'Czy na pewno chcesz usunąć ten rodzaj dokumentu?',
  },
  {
    api: 'amenity',
    label: 'Udogodnienia',
    creationLabel: 'Dodaj udogodnienie',
    fields: SimpleDictionaryFormConfig,
    columns: SimpleDictionaryTableConfig,
    editable: true,
    editWithId: true,
    withHeader: false,
    deleteModalTitle: 'Usunięcie udogodnienia',
    deleteModalDescription: 'Czy na pewno chcesz usunąć to udogodnienie?',
  },
  {
    api: 'amenity/group',
    label: 'Grupy udogodnień',
    creationLabel: 'Dodaj grupę',
    fields: AmenityGroupFormConfig,
    columns: AmenityGroupTableConfig,
    editable: true,
    editWithId: true,
    deleteModalTitle: 'Usunięcie grrupy',
    deleteModalDescription: 'Czy na pewno chcesz usunąć tą grupę?',
    modalSize: "xl"
  },
  {
    api: 'rule',
    label: 'Zasady pobytu',
    creationLabel: 'Dodaj zasadę pobytu',
    fields: SimpleDictionaryFormConfig,
    columns: SimpleDictionaryTableConfig,
    editable: true,
    editWithId: true,
    withHeader: false,
    deleteModalTitle: 'Usunięcie zasady pobytu',
    deleteModalDescription: 'Czy na pewno chcesz usunąć tą zasadę pobytu?',
  },
];
